export default __webpack_public_path__ + "static/linear-knowledge-time-db3580b6e878015479004925c8e4e7da.png";